// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js";
import { createApp, nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import VueRouterRoutes from "./router/index";
import { createGtm } from "@gtm-support/vue-gtm";
import VueHighlightJS from "vue-highlightjs";
import App from "./App.vue";
import "./styles/main.scss";
import gtmHelpers from "./functions/gtm.js";
import {
  setupGlobalClickTracking,
  trackPageDepth,
  setupScrollTracking,
} from "./functions/gtm-tracking";
import { setupPageScrollReveal } from "./functions/scrollReveal";
import VueClipboard from "vue-clipboard2";

var thisHostName = window.location.hostname.toLowerCase();
var isLoaded = true;

// partnerstack global store ps_xid for registration tracking
// we clear it once logged in
try {
  const query = new URLSearchParams(location.search)
  if (query && query.get('ps_xid')) {
    localStorage.setItem('ps_xid', query.get('ps_xid'));
  }
} catch (e) {
  console.log(e)
}

//google gclid tracking use for registration tracking
// we clear it once logged in
try {
  const query = new URLSearchParams(location.search)
  if (query && query.get('gclid')) {
    localStorage.setItem('gclid', query.get('gclid'));
  }
}
catch (e) {
  console.log(e)
}

if (
  thisHostName.indexOf("mpmserv.co.uk") > -1 ||
  thisHostName.indexOf("mpmailserv1.co.uk") > -1 ||
  thisHostName.indexOf("mpmserv1.com") > -1
) {
  window.open("http://mpmserv.co.uk", "_self");
  isLoaded = false;
}

if (
  thisHostName.indexOf("transpond") < 0 &&
  thisHostName.indexOf("mpzmail") < 0 &&
  thisHostName.indexOf("127.0.0.1") < 0 &&
  thisHostName.indexOf("localhost") < 0 &&
  thisHostName.indexOf("amplifyapp") < 0 &&
  thisHostName.indexOf("ukemailmarketing") < 0
) {
  window.open("http://" + thisHostName + "/cp3/", "_self");
  isLoaded = false;
}

if (isLoaded === true) {
  const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes: VueRouterRoutes.routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return {
          el: to.hash,
          behavior: "smooth",
        };
      }
      if (savedPosition) {
        return savedPosition;
      }
      return { top: 0 };
    },
  });

  setupGlobalClickTracking();

  let cleanupScroll = () => {};
  let cleanupReveal = () => {};

  router.afterEach((to, from) => {
    const isInitialNavigation = from.matched.length === 0;
    if (!isInitialNavigation && to.path === from.path) return;
    trackPageDepth();
    cleanupScroll();
    cleanupScroll = setupScrollTracking([25, 50, 75, 90]);
    cleanupReveal();
    nextTick(() => {
      cleanupReveal = setupPageScrollReveal();
    });
  });

  const gtmEnabled = gtmHelpers.getConsentState();

  const app = createApp(App);
  app.use(router);
  app.use(VueClipboard);
  app.use(VueHighlightJS);

  const gtmInstance = createGtm({
    id: "GTM-W7KPSXK",
    enabled: gtmEnabled, // Initially disable GTM until consent is granted
    debug: true
  });

  //update consent
  app.use(gtmInstance);

  app.mount("#app");

  gtmHelpers.init(gtmInstance);

  document.addEventListener("DOMContentLoaded", () => {
    // const applyConsentUpdate = () => {
    // if (typeof window.gtag === "function") {
    //   // Apply consent settings
    //   window.gtag('consent', 'update', {
    //     ad_storage: gtmEnabled ? 'granted' : 'denied',
    //     analytics_storage: gtmEnabled ? 'granted' : 'denied',
    //     ad_user_data: gtmEnabled ? 'granted' : 'denied',
    //     ad_personalization: gtmEnabled ? 'granted' : 'denied',
    //   });
    // } else {
    //   // Retry every 100ms until gtag is available
    //   setTimeout(applyConsentUpdate, 100);
    // }
    // };

    // Start the polling function
    //applyConsentUpdate();
  });
}
